import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PickupService } from 'src/app/services/pickup.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { environment } from 'src/environments/environment';
import { VentanaConfirmacionComponent } from '../../modal/ventana-confirmacion/ventana-confirmacion.component';
import { Bulto } from 'src/app/interfaces/Bulto';
import { StatusLogService } from 'src/app/services/status-log.service';
import { TempStateService } from '../../services/temp-state.service';
import { ScannerModalComponent } from 'src/app/scanner-modal/scanner-modal.component';
import { ScannerModalEntregaComponent } from 'src/app/scanner-modal-entrega/scanner-modal-entrega.component';
import { QueueService } from 'src/app/services/queue.service';

interface UbicacionConBultos {
  escaneada: boolean;
  bultos: Bulto[];
}

@Component({
  selector: 'app-opciones',
  templateUrl: './opciones.component.html',
  styleUrls: ['./opciones.component.scss'],
})
export class OpcionesComponent implements OnInit {
  bultos: Bulto[] = [];
  bultosPorUbicacion: any;
  bultos_colapsados: boolean = false;
  comentario: string = '';
  screen_height: number = window.screen.height;
  screen_width: number = window.screen.width;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    public pickupService: PickupService,
    public http: HttpClient,
    public utilityService: UtilitiesService,
    private statusService: StatusLogService,
    private tempStateService: TempStateService,
    public queueService: QueueService
  ) {}

  @HostListener('window:focus', ['$event'])
  onFocus(event: any) {
    console.log('Back to focus', event);
  }

  async ngOnInit() {
    this.refresh();
  }

  async refresh() {
    this.utilityService.stopAllActiveCameras();
    if (!this.pickupService.pedidoActivo.sg123) {
      let pedidoActivo = JSON.parse(
        await this.utilityService.getObject('pedidoActivo')
      );

      if (pedidoActivo.null) this.router.navigate(['/inicio']);
      else this.pickupService.pedidoActivo = pedidoActivo;
    }

    console.log(this.pickupService.pedidoActivo);

    this.statusService.changePedidoStatus(this.pickupService.pedidoActivo, 1);
    this.loadUbicacionesConBultos();
  }

  loadUbicacionesConBultos() {
    console.log('Cargando ubicaciones con bultos para el pedido activo:', [
      ...this.pickupService.pedidoActivo.bultos,
    ]);
    const queueData = this.queueService.current_bineo.get(
      this.pickupService.pedidoActivo.sg123
    );

    this.bultosPorUbicacion = this.pickupService.pedidoActivo.bultos
      .map((b) => {
        return {
          ...b,
          enCola: queueData
            ? queueData.some((cola) => cola.id === b.id)
            : false,
        };
      })
      .reduce(
        (
          acc: {
            [key: string]: UbicacionConBultos;
          },
          bulto: Bulto
        ) => {
          const ubicacion = bulto.ubicacion || 'sin ubicacion';
          if (!acc[ubicacion]) {
            acc[ubicacion] = {
              escaneada: false,
              bultos: [],
            };
          }

          acc[ubicacion].bultos.push(bulto);
          return acc;
        },
        {}
      );
  }

  logLlamarCliente(telefono: string) {
    this.tempStateService.updateCondition(
      this.pickupService.pedidoActivo.sg123,
      {
        key: 'clientCall',
        value: new Date().toISOString(),
      }
    );
    sessionStorage.setItem(
      'ultimo_sg_llamado',
      this.pickupService.pedidoActivo.sg123
    );

    let log_info = {
      telefono: `+${telefono}`,
      pedido: this.pickupService.pedidoActivo.sg123,
      id_usuario: this.pickupService.usuario.id,
      entrante: 0,
      codigo_local: this.pickupService.usuario.codigo_local,
    };

    this.pickupService.logLlamarCliente(log_info);
  }

  resetLlegada() {
    let url = environment.api_host + '/api/reset-llegada-app';
    let sg123 = this.pickupService.pedidoActivo.sg123;

    let httpParams = new HttpParams()
      .append('orden', sg123)
      //REVISAR SI EFECTIVAMENTE ES EL IDRUNNER EL USUARIO.ID
      .append('id_runner', this.pickupService.usuario.id);

    this.http.post(url, httpParams).subscribe((res) => {
      this.router.navigate(['/inicio']);
    });
  }

  goComentarios() {
    this.router.navigate(['/comentarios'], {
      queryParams: { tipo_entrada: 'editar' },
    });
  }

  pickerManual() {
    this.escanearQr();
  }

  reagendar() {
    this.router.navigate(['/reagendar']);
  }

  async presentAlertConfirm() {
    var tiempoExpirado: boolean = false;
    var sg_llamado: boolean = false;
    var ultimo_sg_llamado = sessionStorage.getItem('ultimo_sg_llamado');

    if (ultimo_sg_llamado == this.pickupService.pedidoActivo.sg123)
      sg_llamado = true;

    //verificar tiempo
    if (this.pickupService.pedidoActivo.ts_llegada_totem) {
      let fechaObjeto = new Date(
        this.pickupService.pedidoActivo.ts_llegada_totem
      );

      let fechaActual = new Date();
      let diferencia = fechaActual.getTime() - fechaObjeto.getTime();
      let minutosDiferencia = Math.floor(diferencia / 1000 / 60);
      if (minutosDiferencia > 5) tiempoExpirado = true;

      console.log('tiempo : ' + minutosDiferencia);
    }

    // @ts-ignore
    if (tiempoExpirado && !sg_llamado) {
      const modal = this.dialog.open(VentanaConfirmacionComponent, {
        data: {
          disclaimer: `Acción no permitida, ya que el cliente lleva en espera más de 5 minutos`,
          botones_opciones: false,
        },
        height: this.utilityService.modal_height / 1.9 + 'px',
        width: this.utilityService.modal_width + 'px',
        maxHeight: this.screen_height + 'px',
        maxWidth: this.screen_width + 'px',
        disableClose: true,
      });
      // @ts-ignore
    } else if (
      !sg_llamado &&
      (this.pickupService.pedidoActivo.notificacion_llegada == 'meson' ||
        this.pickupService.pedidoActivo.notificacion_llegada == 'qr' ||
        (+this.pickupService.pedidoActivo.distancia > 0 &&
          +this.pickupService.pedidoActivo.distancia < 500))
    ) {
      const modal = this.dialog.open(VentanaConfirmacionComponent, {
        data: {
          disclaimer: `Acción no permitida, ya que el cliente está en el local`,
          botones_opciones: false,
        },
        height: this.utilityService.modal_height / 1.9 + 'px',
        width: this.utilityService.modal_width + 'px',
        maxHeight: this.screen_height + 'px',
        maxWidth: this.screen_width + 'px',
        disableClose: true,
      });
    } else {
      const modal = this.dialog.open(VentanaConfirmacionComponent, {
        data: {
          disclaimer: `¿Esta seguro/a que el cliente ${this.pickupService.pedidoActivo.nombrecliente} no ha llegado aun?`,
          botones_opciones: true,
        },
        height: this.utilityService.modal_height / 1.5 + 'px',
        width: this.utilityService.modal_width + 'px',
        maxHeight: this.screen_height + 'px',
        maxWidth: this.screen_width + 'px',
        disableClose: true,
      });

      modal.afterClosed().subscribe((response) => {
        if (response) {
          this.resetLlegada();
        }
      });
    }
  }

  volverListado() {
    this.router.navigate(['/inicio']);
  }

  detenerSonido() {
    this.pickupService.detenerSonido();
  }

  resetLlegadaLocker() {
    return this.hasPassedTheLockTime() || this.hasPassesTheQRorIVRLockTime();
  }

  hasPassedTheLockTime() {
    if (this.pickupService.pedidoActivo.status === 'Cliente esperando') {
      if (this.pickupService.pedidoActivo.ts_llegada_totem) {
        return !(
          this.utilityService.getTimePastTill(
            this.pickupService.pedidoActivo.ts_llegada_totem,
            false
          ) >=
            60 * (this.pickupService.usuario.reset_bloqueo_time ?? 10) ||
          this.tempStateService.getCondition(
            this.pickupService.pedidoActivo.sg123,
            'clientCall'
          )
        );
      }
    }
    return false;
  }

  hasPassesTheQRorIVRLockTime() {
    if (
      this.pickupService.pedidoActivo.status === 'Cliente esperando' &&
      (this.pickupService.pedidoActivo.notificacion_llegada === 'llamada' ||
        this.pickupService.pedidoActivo.notificacion_llegada === 'meson')
    ) {
      if (this.pickupService.pedidoActivo.ts_llegada_totem) {
        if (
          this.tempStateService.getCondition(
            this.pickupService.pedidoActivo.sg123,
            'clientCall'
          )
        ) {
          return !(
            this.utilityService.getTimePastTill(
              this.pickupService.pedidoActivo.ts_llegada_totem,
              true
            ) >=
              60 * (this.pickupService.usuario.reset_bloqueo_time ?? 10) ||
            this.utilityService.getTimePastTill(
              this.tempStateService
                .getCondition(
                  this.pickupService.pedidoActivo.sg123,
                  'clientCall'
                )
                ?.toString() ?? '',
              false
            ) >=
              60 * 10
          );
        }
      }
    }
    return false;
  }

  escanearQr(): void {
    const dialogRef = this.dialog.open(ScannerModalComponent, {
      width: this.screen_width + 'px',
      height: this.screen_height + 'px',
      maxWidth: this.screen_width + 'px',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result: any | undefined) => {
      if (!result) {
        this.refresh();
      }
    });
  }

  escanearQrEntrega(): void {
    console.log(this.screen_width);
    const dialogRef = this.dialog.open(ScannerModalEntregaComponent, {
      width: this.screen_width + 'px',
      height: this.screen_height + 'px',
      maxWidth: this.screen_width + 'px',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result: any | undefined) => {
      if (result) {
      } else {
        console.warn('No se capturó ningún QR.');
      }
      this.refresh();
    });
  }

  colapsarBultos() {
    this.bultos_colapsados = !this.bultos_colapsados;
    return this.bultos_colapsados;
  }

  getUbicaciones(): string[] {
    return Object.keys(this.bultosPorUbicacion);
  }
}
